import { format } from 'url'
import { getDataAttr } from 'lib/server_params'

const SEND_TYPE = 'send'
const BUY_TYPE = 'buy'

const PATH_BASE = '/myaccount/transfer'
const POOLS_PATH_SUFFIX = 'external/pools'
const DEPPLINK_PATH_SUFFIX = 'external/'

export function generateFF(
  { amount, currencyCode, campaign, anon, note },
  bypassToGS
) {
  const type = bypassToGS ? BUY_TYPE : SEND_TYPE
  return format({
    pathname: `${PATH_BASE}/${type}/${POOLS_PATH_SUFFIX}`,
    query: {
      amount,
      log: getDataAttr('logid'),
      currencyCode,
      campaign,
      anon,
      note,
    },
  })
}

export function generateGS({ amount, currencyCode, recipientEmail, note }) {
  if (!recipientEmail) {
    return `${PATH_BASE}/${BUY_TYPE}`
  }
  return format({
    pathname: `${PATH_BASE}/${BUY_TYPE}/${DEPPLINK_PATH_SUFFIX}`,
    query: {
      amount,
      currencyCode,
      note,
      recipient: recipientEmail,
    },
  })
}
